<div class="assign-preview-banner" [ngClass]="selectedAsset.assetTypeId">
  <!-- assign preview banner details -->
  <div class="banner-details">
    <!-- Back to Assignable List -->
    <div class="back-link-container">
      @if (fromAssignPreview) {
        <p
          class="back-link-container-p"
          (click)="goBackToAssign()"
          >
          <mat-icon class="">keyboard_arrow_left</mat-icon>
          <span>Back to {{ backLinkName() }}</span>
        </p>
      }
    </div>
    <!-- Assignable Icon and Name -->
    <div class="banner-info-container">
      <h2
        class="banner-title"
        [innerHtml]="this.getAssetName(selectedAsset)"
        [ngClass]="headBannerClassReturn(selectedAsset)"
      ></h2>
      <div class="banner-sub-title-container">
        <img class="icon-33-x-33" [src]="getIconPath()" />
        <h4
          class="banner-assignable-type-name"
          [innerHtml]="getAssignableSubTitle(selectedAsset)"
        ></h4>
      </div>
    </div>
  </div>

  <!-- assign preview banner options -->
  @if (showBannerOptions) {
    <div class="banner-options">
      <!-- Add to Favorites -->
      <!--            <div class="banner-options-favorites">-->
    <!--            </div>-->
    <!-- Quick Assign -->
    <!--            <div class="banner-options-quick-assign">-->
  <!--            </div>-->
  <!-- Assign -->
  @if (selectedAsset?.isAssignable) {
    <div class="banner-options-assign">
      <button
        mat-raised-button
        class="banner-options-assign-button"
                [ngClass]="{
                    'assign-button-disabled':
                        !selectedAsset ||
                        (creatingLesson &&
                            selectedAsset?.assetTypeId === assetTypeIds.BUNDLE)
                }"
        aria-label="Add/Remove to cart"
        [matTooltip]="getAssignTooltip(assigned)"
        (click)="handleAssignClick()"
                [disabled]="
                    !selectedAsset ||
                    (creatingLesson &&
                        selectedAsset?.assetTypeId === assetTypeIds.BUNDLE)
                "
        >
        Assign
        @if (!assigned) {
          <mat-icon class="assign-button-icon"
            >add_circle</mat-icon
            >
          }
          @if (assigned) {
            <mat-icon class="assign-button-icon"
              >remove_circle</mat-icon
              >
            }
          </button>
        </div>
      }
    </div>
  }

  @if (showProfileMessaging) {
    <profile-messaging-container
      [radiusType]="'square'"
      class="profile-messaging-section"
    ></profile-messaging-container>
  }
</div>
